import { Checkbox } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';
import { VisitSettlementFormController } from '../VisitSettlementForm';

const t = visitSettlementTranslationKeys.shared.form.payment.acceptedCorrectlyCheckbox;

type PaymentAcceptedCorrectlyCheckboxProps = Pick<VisitSettlementFormController, 'register'>;

export const PaymentAcceptedCorrectlyCheckbox = (props: PaymentAcceptedCorrectlyCheckboxProps): JSX.Element => {
   return (
      <Checkbox
         testId={'paymentAcceptedCorrectly'}
         controller={props.register('payment.acceptedCorrectly')}
         label={t.label}
         defaultValue={false}
      />
   );
};
